import React, { useState } from "react";
import { Button } from "react-bootstrap";
import OutlookSentMails from "./ComposeModal";
import OutlookMails from "./OutLookMails";


export default function OutlookIntegration() {
  return (
    <><div className="p-3" >
     
      <OutlookMails/>
      </div>
    </>
  );
}
